import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
import AutoNumeric from 'autonumeric';
var Home = {
  pn: 'div[data-name="home"]',
  watch: null,
  init: function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(today) {
      var self, $input;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = this;
              Base.branches.forEach(function (item, i) {
                var count = i + 1;
                var b = $("<div class=\"branch\" data-id=\"".concat(item.id, "-").concat(item.work_shift, "\"><div class=\"name\">").concat(item.name, "</div><div class=\"employees\"></div></div>"));
                $(self.pn + ' .branches').append(b);

                if (count % 2 === 0 || count == Base.branches.length) {
                  $(self.pn + ' .branches').append('<div class="clearfix"></div>');
                }
              });
              self.getCalendar(today);
              $input = $(self.pn + ' .selected-date');
              Base.app.calendar.create({
                inputEl: $input,
                dateFormat: 'd/m/yyyy'
              });
              $input.change(function () {
                $(self.pn + ' ');
                $(self.pn + " .branch .employees").html('');
                $(self.pn + ' .employees-dayoff[data-status="1"] .list').html('');
                self.getCalendar($(this).val());
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function init(_x) {
      return _init.apply(this, arguments);
    }

    return init;
  }(),
  getCalendar: function () {
    var _getCalendar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(selected_date) {
      var self, preloader, rs, rows, note;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = this;
              preloader = Base.app.dialog.preloader();
              _context2.next = 4;
              return Base.api('Workingcalendar', 'getWorkingCalendar', {
                selected_date: selected_date
              });

            case 4:
              rs = _context2.sent;
              preloader.close();
              rows = rs.rows;
              rows.forEach(function (item, i) {
                var is_me = '';
                if (Base.user) is_me = Base.user.id == item.id_emp ? 'color-orange' : '';
                var $emp = $("<div class=\"chip ".concat(is_me, "\"><div class=\"chip-label\">").concat(item.name, "</div></div>"));
                $(self.pn + " .branch[data-id=\"".concat(item.id_branch, "-").concat(item.work_shift, "\"] .employees")).append($emp);
                if (parseInt(item.status) === 1) $(self.pn + ' .employees-dayoff[data-status="1"] .list').append($emp);
              });
              note = rs.note ? rs.note.trim() : '';

              if (note.length > 1) {
                $(self.pn + ' .working-note').text(note);
                $(self.pn + ' .working-note').removeClass('display-none');
              } else {
                $(self.pn + ' .working-note').text('');
                $(self.pn + ' .working-note').addClass('display-none');
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getCalendar(_x2) {
      return _getCalendar.apply(this, arguments);
    }

    return getCalendar;
  }()
};
export default (function ($prop, ctx) {
  var today = moment().format(Base.dateFormat);
  ctx.$on('pageInit', function () {
    if (!Base.branchesLoaded) {
      var preloader = Base.app.dialog.preloader('Khởi động chương trình...');
      var watch = setInterval(function () {
        if (Base.branchesLoaded) {
          clearInterval(watch);
          preloader.close();
          Home.init(today);
        }
      }, 500);
    } else {
      Home.init(today);
    }
  });
  var name = 'bạn';

  var profile = function profile() {
    Base.profile();
  }; // let name = Base.user.name;
  // let branch = Base.branches.get(Base.user.default_branch);
  // let today = moment().format(Base.dateFormat);
  // let daysInMonth = moment().daysInMonth();


  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="home">
    <div class="page-content">
      <div class="block block-strong no-margin text-align-center">
        <input class="selected-date" value="${today}" readonly/>
      </div>

      <div class="block display-none working-note">
        Ghi chú...
      </div>
      <div class="branches">
      </div>

      <div class="employees-dayoff" data-status="1">
        <div class="title">Nghỉ</div>
        <div class="list no-margin padding-2"></div>
      </div>

    </div>
  </div>
`
    }
    ;
});